module.exports = __webpack_public_path__ + "static/media/image-6.7f24295b.png";